import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "diagnosis-table-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", { class: "io-mfe-ig-dt-col-left-spacer" }, null, -1)
const _hoisted_3 = {
  key: "action",
  class: "io-mfe-ig-dt-col-actions"
}
const _hoisted_4 = {
  class: "pdx io-mfe-ig-dt-col-pdx",
  key: "pdx"
}
const _hoisted_5 = {
  key: "drgModifier",
  class: "io-mfe-ig-dt-col-modifier"
}
const _hoisted_6 = {
  key: "code",
  class: "io-mfe-ig-dt-col-code"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: "description",
  class: "io-mfe-ig-dt-col-desc"
}
const _hoisted_9 = { class: "ellipsis" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: "poa",
  class: "io-mfe-ig-dt-col-poa"
}
const _hoisted_13 = {
  key: 2,
  class: "io-mfe-ig-dt-col-quality-risk"
}
const _hoisted_14 = { key: "quality" }
const _hoisted_15 = { key: "risk" }

import {QTableProps, useQuasar} from 'quasar';
import DataTable from 'components/grouper-common/DataTable.vue';
import { ref, watch } from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { CodeType } from 'src/contracts/codeType';
import { storeToRefs } from 'pinia';
import {
    presentOnAdmissionDisplayMap,
    presentOnAdmissionMap,
    presentOnAdmissionsDisplayValues
} from 'src/common/poaUtll';
import { useLayoutStore } from 'stores/layout-store';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { getDxColumns } from 'components/grouper-common/common-constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosisPane',
  setup(__props) {

const grouperStore = useGrouperStore();
const $q = useQuasar()
const { diagnosisCodes, resequence } = storeToRefs(grouperStore);

const { layoutMode } = storeToRefs(useLayoutStore());

let currentCode: DiagnosisCode | undefined = undefined;
let currentRow = ref(-1);
const columns = ref<QTableProps['columns']>(getDxColumns(layoutMode.value));

watch(layoutMode, (newLayoutMode: GrouperLayoutMode) => {
  columns.value = getDxColumns(newLayoutMode);
});

function rowClasses(index: number): string {
    const classList = [];
    if (editing(index)) {
        classList.push('editing-row');
    } else if (index % 2 === 0) {
        classList.push('iodine-alternate-table-row');
    } else {
      classList.push('bg-white');
      classList.push('text-black');
    }

    if (index == 0) {
      classList.push('primary-row');
    }
    return classList.join(' ');
}

function deleteCode(index: number): void {
    diagnosisCodes.value?.splice(index, 1);
    currentRow.value = -1;
    grouperStore.recalculateNeeded();
}

function editCode(index: number, editing = true): void {
    // reset previous row before editing new row
    if (currentRow.value != index && currentRow.value > -1) {
      if (currentCode) {
        diagnosisCodes.value[currentRow.value] = currentCode;
        grouperStore.recalculateNeeded();
      }

    }
    // make a copy of the row for reset
    currentCode = index >= 0 ? diagnosisCodes.value[index] : undefined;
    currentRow.value = editing ? index : -1;
}

function editing(index: number): boolean {
    return currentRow.value === index;
}

function saveCode() {
    currentRow.value = -1;
}

function resetCode(index: number): void {
    diagnosisCodes.value[index] = currentCode || diagnosisCodes.value[index];
    currentRow.value = -1;
}

function makePrinciple(index: number): void {
    diagnosisCodes.value?.unshift(diagnosisCodes.value?.splice(index, 1)[0]);
    grouperStore.recalculateNeeded();
}

function searchCodes(text: string | undefined, index: number) {
  useGrouperStore().searchCodes(text, 'DIAGNOSIS').then(data =>  diagnosisCodes.value[index].description = data);
}

function setPOA(value: string, index: number) {
    diagnosisCodes.value[index].present_on_admission = presentOnAdmissionDisplayMap[value];
    currentRow.value = -1;
    grouperStore.recalculateNeeded();
}

function titleText() {
    return `Diagnoses (${diagnosisCodes.value?.length || 0})`
}

function moveElements(arr: unknown[], newPosition: number, oldPosition: number) {
  let element = arr.splice(newPosition, 1)[0];
  arr.splice(oldPosition, 0, element);

  return arr;
}

function dxReorderd(event: CustomEvent) {
  if(resequence.value) {
    $q.dialog({
      color: 'white',
      textColor: 'black',
      html: true,
      title: '<span class="q-dialog-custom__title">Resequencing Conflict</span>',
      message: '<div class="q-dialog-custom__body">' +
                  '<div style="margin-bottom: 20px">Moving this code is in conflict with automatic resequencing.</div>' +
                  '<div>Would you like to proceed with moving and turn off automatic resequencing?</div>' +
              '</div>',
      ok: {
        class: 'dialog-button',
        label: 'Yes'
      },
      cancel: {
        class: 'dialog-button',
        label: 'No'
      }
    }).onOk(() => {
      grouperStore.changeResequence();
    }).onCancel(() => {
      const diagnosisCodesArray = diagnosisCodes.value;
      moveElements(diagnosisCodesArray, event.newIndex, event.oldIndex)
      diagnosisCodes.value = diagnosisCodesArray;
    })
  } else {
    grouperStore.recalculateNeeded();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTable, {
      title: titleText(),
      rows: _unref(diagnosisCodes),
      columns: columns.value,
      type: _unref(CodeType).Diagnosis,
      onReorder: dxReorderd
    }, {
      "dt-thead": _withCtx(() => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (col) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass(["ellipsis", (col.headerClasses ? col.headerClasses : '') + ` io-mfe-ig-dt-col-${col.name}`]),
                key: col.name
              }, _toDisplayString(col.label), 3))
            }), 128))
          ])
        ])
      ]),
      "dt-rows": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diagnosisCodes), (row, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass(rowClasses(index))
          }, [
            _hoisted_2,
            _createElementVNode("td", _hoisted_3, [
              _createVNode(_component_q_btn_dropdown, {
                "no-caps": "",
                dense: "",
                flat: "",
                unelevated: "",
                class: "text-none io-mfe-ig-icon-button-small q-btn--round",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (makePrinciple(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Make Principle")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Open in Search")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (deleteCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Delete Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (editCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edit")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup],
                        [_vShow, !editing(index)]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, {
                            onClick: ($event: any) => (resetCode(index))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Reset")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)), [
                        [_directive_close_popup],
                        [_vShow, editing(index)]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("td", _hoisted_4, [
              (row.pdx)
                ? (_openBlock(), _createBlock(_component_q_chip, {
                    key: index,
                    class: "Pdx"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Pdx ")
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.drgModifier, (drgModifier, index) => {
                return (_openBlock(), _createBlock(_component_q_chip, {
                  key: index,
                  class: _normalizeClass(drgModifier)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(drgModifier), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            _createElementVNode("td", _hoisted_6, [
              (!editing(index))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (editCode(index))
                  }, [
                    (row.edit)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "fa-solid fa-flag-pennant",
                          size: "xs",
                          class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning'])
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Edits Available")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(row.code), 1)
                  ], 8, _hoisted_7))
                : _createCommentVNode("", true),
              (editing(index))
                ? (_openBlock(), _createBlock(_component_q_input, {
                    key: 1,
                    dense: "",
                    outlined: "",
                    modelValue: row.code,
                    "onUpdate:modelValue": [($event: any) => ((row.code) = $event), ($event: any) => (searchCodes(row.code, index))],
                    placeholder: "Add Code",
                    autofocus: "",
                    size: "16px",
                    onKeydown: [
                      _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["enter"])),
                      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (saveCode()), ["prevent"]), ["tab"]))
                    ]
                  }, {
                    prepend: _withCtx(() => [
                      (row.edit)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-flag-pennant",
                            size: "xs",
                            class: _normalizeClass(["edit-flag", row.edit.level == 'Critical' ? 'critical' : 'warning'])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Edits Available")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["class"]))
                        : _createCommentVNode("", true)
                    ]),
                    append: _withCtx(() => [
                      (row.description === '' && row.code)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "fa-solid fa-circle-exclamation",
                            size: "16px"
                          }))
                        : (row.description && row.code)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 1,
                              name: "fa-solid fa-trash-can",
                              onClick: ($event: any) => (deleteCode(index)),
                              size: "16px"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.description), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_9, _toDisplayString(row.description), 1)
            ]),
            (!editing(index))
              ? (_openBlock(), _createElementBlock("td", {
                  key: "poa",
                  onClick: ($event: any) => (editCode(index)),
                  class: "io-mfe-ig-dt-col-poa"
                }, [
                  (row.present_on_admission)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(presentOnAdmissionMap)[row.present_on_admission]), 1))
                    : (_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        name: "fa-solid fa-triangle-exclamation",
                        size: "16px"
                      }))
                ], 8, _hoisted_10))
              : _createCommentVNode("", true),
            (editing(index))
              ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn_dropdown, {
                      label: _unref(presentOnAdmissionMap)[row.present_on_admission] || 'Set POA',
                      class: "poa-dropdown"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presentOnAdmissionsDisplayValues), (poa, poaIndex) => {
                              return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                key: poaIndex,
                                clickable: "",
                                onClick: ($event: any) => (setPOA(poa, index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_section, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(poa), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["label"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) == _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(quality)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(quality), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(risk)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(risk), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) != _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.quality, (quality, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(quality)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(quality), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_unref(layoutMode) != _unref(GrouperLayoutMode).consolidated)
              ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.risk, (risk, index) => {
                    return (_openBlock(), _createBlock(_component_q_chip, {
                      key: index,
                      class: _normalizeClass(risk)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(risk), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ]),
      _: 1
    }, 8, ["title", "rows", "columns", "type"])
  ]))
}
}

})